/* eslint-disable no-unused-vars */
const FormatURLParams = dto => {
  dto = FilterSortByDesc(dto);
  dto = RemoveEmptyArrays(dto);

  return new URLSearchParams(dto);
};

const FormatarParametrosComArray = (dto, params) => {
  Object.entries(dto).forEach(([key, value]) => {
    if (key !== 'situacoesList' && value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, v));
      } else {
        params.append(key, value);
      }
    }
  });
  return params;
}

const FilterSortByDesc = dto => {
  if (
    'sortBy' in dto &&
    'sortDesc' in dto &&
    !dto.sortBy.length &&
    dto.sortDesc.length
  ) {
    delete dto.sortBy;
    delete dto.sortDesc;
  }
  return dto;
};

const RemoveEmptyArrays = dto => {
  return Object.fromEntries(
    Object.entries(dto).filter(([_, value]) => {
      if (Array.isArray(value) && !value.length) return false;
      return value || value === 0 ? true : false;
    })
  );
};

module.exports = {
  FormatURLParams,
  FormatarParametrosComArray
};
